export default "__VITE_ASSET__DGH4MppI__"